// @flow
import * as React from 'react';
import ButtonContainer from 'esm-web-pro/components/layout/sidePanel/ButtonContainer';
import { History, Match } from 'react-router-dom';
import { withRouter } from 'react-router';
import { closePanel } from 'esm-web-pro/redux/side-panel';
import { useDispatch } from 'react-redux';


type Props = {
    panelId?: String,
    history: History,
    match: Match,
};

const NavigateBackButton = (props: Props) => {
    const {
        history, match, panelId,
    } = props;

    const dispatch = useDispatch();

    const navigateBack = () => {
        if (panelId) {
            history.push(match.url.split('/layer')[0]);
            dispatch(closePanel(panelId, true));
            return;
        }
        history.push(match.url.split('/layer')[0]);
    };

    return (
        <ButtonContainer handleClick={navigateBack} />
    );
};

NavigateBackButton.defaultProps = {
    panelId: null,
};

export default withRouter(NavigateBackButton);
